const messages = {
  title: "Butikk",
  description: "Velkommen til premieshop. Her kan du løse inn Bridgestone Plus-poengene dine <br/> mot premier fra ulike kategorier. Produktutvalget <br/> oppdateres regelmessig. Vi ønsker deg lykke til med å browse.",
  sort: {
    asc: "Sorter etter: Laveste pris",
    desc: "Sorter etter: Høyeste pris",
  },
  productSearchBox: {
    from: "poeng fra",
    to: "poeng til",
  },
  noProducts: "Søkekriteriene ga ingen resultater",
  quantity: "Antall",
  search: "Søk",
  perPage: "Elementer per side",
  timeUnavailable: "For øyeblikket ikke tilgjengelig",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Poeng per enhet",
    pointsSum: "Sum poeng",
  },
  action: "Handling",
  pointsTotal: "Totalt",
  cartRemainPoints: "Gjenstående poeng i handlekurv",
  shoppingCart: "Handlevogn",
  emptyCart: "Handlevognen er tom.",
  attributes: "Egenskaper",
  selectAddressP: "Vennligst velg leveringsadressen din",
  orderDelivery: "Leveringsadresse",
  selectedProducts: "Valgte produkter",
  orderSummary: "Ordreoversikt",
  contactPerson: "Kontaktperson",
  selectedAddress: "Valgt adresse",
  order: {
    success: "Takk! Bestillingen din var vellykket. Du mottar en ordrebekreftelse i innboksen din om noen minutter.",
    description: "Her finner du en oversikt over bestillingene dine fra premieshop.",
    info: "Her finner du en oversikt over bestillingene dine fra premieshop.",
    date: "Bestillingsdato",
    number: "Ordre nr.",
    status: {
      created: "Opprettet",
      confirm_order: "Bekreft bestilling",
      ready_for_shipment: "Klar for forsendelse",
      rejected: "Avvist",
      processed: "Behandlet",
      shipped: "Sendt",
      returned: "Returnert",
      finished: "Fullført",
    },
    anyOrder: "Ingen bestillinger",
    products: "Produkter",
    quantity_short: "stk",
    itemRemoved: "kan ikke leveres",
  },
  orders: "Bestillinger",
  notEnoughPoints: "Ikke nok poeng tilgjengelig.",
  statusText: "Status",
  outOfStock: "For øyeblikket ikke på lager",
  productUnavailable: "Dette produktet er ikke lenger tilgjengelig.",
  deletedProductsTitle: "Produkter ikke lenger tilgjengelig",
  deletedProductsMessage: "Følgende produkt(er) er ikke lenger tilgjengelige. Fjern dem fra handlekurven for å fortsette.",
  removeSelected: "Fjern valgte",
  clearCart: "Tøm handlekurv",
  removeSelectedConfirm: "Fjerne de valgte produktene fra handlekurven?",
  clearCartConfirm: "Fjerne alle produkter fra handlekurven?",
  incompleteAddress: {
    firstName: "Legg til et fornavn i leveringsadressen",
    lastName: "Legg til et etternavn i leveringsadressen",
    company: "Legg til et firmanavn i leveringsadressen",
    street: "Legg til gate og husnummer i leveringsadressen",
    postalCode: "Legg til postnummer i leveringsadressen",
    city: "Legg til sted i leveringsadressen",
    country: "Legg til land i leveringsadressen",
    phone: "Legg til et telefonnummer i leveringsadressen",
  },
  placeOrder: "Bindende bestilling",
  toOrderDelivery: "Fortsett til leveringsadresse",
  toOrderSummary: "Til bestillingsoversikt",
  productImg: "Produktbilde",
  selectAddressBtn: "Velg adresse",
  perPgae: "Elementer per side",
  categories: {
    advertising: {
      title: "Reklamemateriell",
      desc: "Delta direkte her på plattformen og sikre <br/> 40 ekstra poeng for belønningsklubben.",
    },
    rewards: {
      title: "Eksklusive belønninger",
      desc: "Oppdag bonustilbudet i vårt opplæringssenter eller hos deg.",
    },
    tools: {
      title: "Verkstedverktøy",
      desc: "Bruk poengene dine på tredjepartsopplæring <br/> og reduser kostnadene.",
    },
    trainings: {
      title: "Opplæring og kurs",
      desc: "Oppdag bonustilbudet i vårt opplæringssenter eller hos deg.",
    },
    salesroom: {
      title: "Salgsrom",
      desc: "Gi salgsrommet et løft og tilby kundene et behagelig opphold.",
    },
    hunter: {
      title: "Hunter",
      desc: "Bytt poeng mot attraktivt verkstedsutstyr fra Hunter.",
    },
  },
  bestSold: "Bestselgere",
  seasonal: "Sesong",
  affordable: "Nesten i mål",
  forPoints: "for {points} poeng",
  reachedPoints: "Nødvendige poeng nådd",
  remainingPoints: "{points} poeng gjenstår",
  favoriteProducts: {
    description: "Her finner du produktene du har lagret.",
  },
  categoryPageDescriptionFallback: "Materiell til verkstedet eller andre kvalitetsprodukter med Bridgestone-logo for bedriften din",
  variant: "Valgbare varianter",
};
export default {
  messages,
};
